import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";
import { IconAlertOctagon } from "@tabler/icons-react";
import { Trans } from "@lingui/macro";

import { getAnalyticsAdapter } from "../analytics/AnalyticsAdapter";
import { Button } from "../components/common/Button";
import { EmptyState } from "../components/common/EmptyState";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    getAnalyticsAdapter().track("render_error", {
      message: error.message,
      stack: info.componentStack ?? "",
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <EmptyState
          tone="error"
          icon={<IconAlertOctagon size={24} />}
          title={<Trans>Что-то пошло не так</Trans>}
          description={<Trans>Произошла непредвиденная ошибка. Перезагрузите страницу.</Trans>}
          action={
            <Button variant="secondary" onClick={() => window.location.reload()}>
              <Trans>Перезагрузить</Trans>
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}
